import {auth} from "../firebase/clientApp";

export const getAuthToken = async () => {
    try {
        return "Bearer " + await auth.currentUser?.getIdToken();
    } catch(err) {
        console.log("getAuthToken", err);
    };
};
